export default "__VITE_ASSET__K48EmCJE__"